import React from 'react'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import { useValue, WhenModelValue } from '@morningtrain/react-resources'
import { ProductInfo } from 'ui/elements'
import EnvToModel from 'support/helpers/EnvToModel'
import { Translation } from '@morningtrain/react-translations'
import WhoShouldHandleToggle from '../WhoShouldHandleToggle'
import InventoryDeliveryNoteItemCalculator from 'widgets/inventory/InventoryDeliveryNoteItemCalculator'
import ApplyClassNameWhenValue from 'support/helpers/ApplyClassNameWhenValue'

export default function DeliveryNoteColumns ({ orderStatus }) {
  const itemId = useValue('id')

  return (
    <>
      <Columns.Column className='w-full'>
        <ProductInfo
          image={<Displays.Image name='image' className='max-h-full' />}
          title={<Displays.Text name='name' />}
          text={(<>min. <Displays.Integer name='min_unit' /> <Displays.Text name='unit_type' /></>)}
        />
      </Columns.Column>
      <EnvToModel path={['globals.inventory.order_items', itemId].join('.')}>
        <Columns.Number
          name='holdings'
          alignment='center'
          label={<Translation name='inventory.columns.in_stock' />}
          decimals={0}
        />
        <Columns.Number
          name='total'
          alignment='center'
          label={<Translation name='inventory.columns.amount' />}
          decimals={0}
        />
        <Columns.Currency
          name='total_price'
          alignment='center'
          label={<Translation name='inventory.columns.order_total' />}
        />
        {orderStatus === 'completed'
          ? (
            <>
              <Columns.Column
                name='received'
                label={<Translation name='inventory.columns.received' />}
                alignment='center'
              >
                <ApplyClassNameWhenValue name='received_offset' matches={v => !!v} className='danger'>
                  <Displays.EditInventoryItemQuantity inventoryItemId={itemId} name='received' min={0} useAsInitial='total' />
                </ApplyClassNameWhenValue>
              </Columns.Column>
              <Columns.Column
                label={<Translation name='inventory.columns.should_office_handle' />}
                alignment='center'
              >
                <WhoShouldHandleToggle itemId={itemId} />
              </Columns.Column>
            </>
            )
          : null}
        {orderStatus === 'received'
          ? (
            <>
              <Columns.Number
                name='received'
                label={<Translation name='inventory.columns.received' />}
                alignment='center'
              />
              <Columns.Column>
                <WhenModelValue name='office_should_handle' condition>
                  <Translation name='inventory.fragments.office_should_handle' />
                </WhenModelValue>
              </Columns.Column>
            </>
            )
          : null}
      </EnvToModel>
      {itemId ? (<InventoryDeliveryNoteItemCalculator inventoryItemId={itemId} />) : null}
    </>
  )
}
